// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"55":"975877fb","207":"e6e49be7","531":"925f67aa","545":"d79b8b28","972":"cdb6e44b"}[chunkId] + ".chunk.js");